import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { OdataValueHelperInterface } from '../../interfaces/odata-value-helper.interface';
import { OdataResponse } from '../../interfaces/online-only.interface';
import { ODataValueHelperModel, ValueHelperModel } from '../../models/low-level/value-helper.model';
import { UriUtilitiesService } from '../../services/uri-utilities/uri-utilities.service';
import { isDefined } from '../../utilities/is-defined';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { UserMasterService } from '../user-master/user-master.service';

@Injectable({
    providedIn: 'root',
})
export class OdataValueHelperService implements OdataValueHelperInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly http: HttpClient,
        private readonly userMasterService: UserMasterService,
    ) {}

    /**
     * Performs the remote http transaction using the configuration parameters from the authenticationService and
     * the ConfigInterfaceService settings. Builds the query string and encapsulates the OData call. Returns a
     * promise and resolves it or just passes the unsuccessful promise through.
     */
    public getValueHelpers(): Observable<ValueHelperModel[]> {
        const query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.ValueHelpers,
        );

        return this.http.get<OdataResponse<ODataValueHelperModel>>(query).pipe(
            map((response) => {
                return ODataUtilities.transformResponseDataToArray(response.d)
                    .map((value: ODataValueHelperModel) => ValueHelperModel.fromOData(value))
                    .filter(isDefined);
            }),
            catchError((err) => {
                this.log.error(
                    'getValueHelpers() - request error:  ' + JSON.stringify(err, Object.getOwnPropertyNames(err)),
                );
                return throwError(err);
            }),
        );
    }
}
